module.exports = __webpack_public_path__ + "img/tab1-2@2x.45d1119f.png";